export class BonusSymbol {
	constructor(public readonly multipliers: number[]) {}

	/** Returns the highest possible multiplier from this symbol. */
	public max(): number {
		return Math.max(...this.multipliers);
	}
}

export const BONUS1 = new BonusSymbol([1, 2, 5]);
export const BONUS2 = new BonusSymbol([10, 25, 50]);
export const BONUS3 = new BonusSymbol([100, 250, 500]);
export const BONUS4 = new BonusSymbol([1000, 2500]);

export const BONUS_SYMBOLS: readonly BonusSymbol[] = [BONUS1, BONUS2, BONUS3, BONUS4];

/** Returns the highest possible multiplier from bonus factory.*/
export function getMaxBonusMultiplier(): number {
	return Math.max(...BONUS_SYMBOLS.map((symbol) => symbol.max()));
}
